export type ReduxAction<VT> = {
    value?: VT
    type: string
}

export const ADD_CAMPAIGN = "ADD_CAMPAIGN";


export const JWT_RECEIVED = "JWT_RECEIVED";
export const LOGOUT = "LOGOUT";